import { render, staticRenderFns } from "./MemberOrderDelivery.vue?vue&type=template&id=58974c97&scoped=true"
import script from "./MemberOrderDelivery.vue?vue&type=script&lang=js"
export * from "./MemberOrderDelivery.vue?vue&type=script&lang=js"
import style0 from "./MemberOrderDelivery.vue?vue&type=style&index=0&id=58974c97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58974c97",
  null
  
)

export default component.exports